<script setup lang="ts">
import { computed } from 'vue';
import { AlertTriangle } from 'lucide-vue-next';
import { confirmState } from '@/composables/useConfirm';
import BaseModal from './BaseModal.vue';
import BaseButton from './BaseButton.vue';

const reasonMissing = computed(() => confirmState.requireReason === true && confirmState.reason.trim().length < 3);

function close(result: string | false) {
  confirmState.open = false;
  confirmState.resolve?.(result);
}
</script>

<template>
  <BaseModal :open="confirmState.open" :title="confirmState.title" size="sm" @close="close(false)">
    <div class="flex gap-3">
      <AlertTriangle v-if="confirmState.danger" class="h-6 w-6 shrink-0 text-red-500" />
      <div class="flex-1 space-y-3">
        <p v-if="confirmState.message" class="text-sm text-muted">{{ confirmState.message }}</p>
        <div v-if="confirmState.requireReason">
          <label class="label" for="confirm-reason">
            {{ confirmState.reasonLabel }}<span v-if="confirmState.requireReason === true" class="text-red-500"> *</span>
          </label>
          <textarea id="confirm-reason" v-model="confirmState.reason" class="input" rows="3" maxlength="500" />
        </div>
      </div>
    </div>
    <template #footer>
      <BaseButton variant="secondary" @click="close(false)">Cancel</BaseButton>
      <BaseButton :variant="confirmState.danger ? 'danger' : 'primary'" :disabled="reasonMissing" @click="close(confirmState.reason.trim())">
        {{ confirmState.confirmText }}
      </BaseButton>
    </template>
  </BaseModal>
</template>
